// VIDEO MODAL
let modalVideo = document.getElementById("videoModal");
let closeModalVideo = document.querySelector(".close_modal_video");
let blockVideoContent = document.querySelector(".block_modal_video");

if (closeModalVideo !== null) {
  closeModalVideo.onclick = function () {
    modalVideo.style.display = "none";
    unlockScroll();
    removeVideo();
  };
}
window.addEventListener("click", function (event) {
  if (event.target == modalVideo) {
    modalVideo.style.display = "none";
    unlockScroll();
    removeVideo();
  }
});

export function addListenerOnEl() {
  document.addEventListener("click", function (event) {
    if (event.target.closest(".watch_video_modal") !== null) {
      removeVideo();
      getDataFromBtn(event.target.closest(".watch_video_modal"));
    }
  });
}

function getDataFromBtn(btn) {
  let response;
  if (
    btn.hasAttribute("data-video-src") ||
    btn.hasAttribute("data-video-type") ||
    btn.hasAttribute("data-video-link")
  ) {
    if (btn.getAttribute("data-video-link") == null) {
      response = videoServerHtml(
        btn.getAttribute("data-video-src"),
        btn.getAttribute("data-video-type")
      );
    } else {
      response = videoLinkHtml(btn.getAttribute("data-video-link"));
    }
    setHtmlVideoToModal(response);
  }
  if (btn.hasAttribute("data-sketchfab-id")) {
    getSketchfabModel(btn.getAttribute("data-sketchfab-id"));
  }
}
function getSketchfabModel(id) {
  const request = new XMLHttpRequest();
  let response;
  const url =
    "https://sketchfab.com/oembed?url=https://sketchfab.com/models/" + id;
  request.open("GET", url);
  request.setRequestHeader("Content-Type", "application/x-www-form-url");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      response = JSON.parse(request.response);
      console.log(response.html);
      if (response.html !== undefined) {
        setHtmlVideoToModal(response.html);
      }
    } else if (request.readyState === 4 && request.status === 404) {
      let textError =
        '<div class="sketchfab_model_error">' +
        document.querySelector("#sketchfab_model_error").innerHTML +
        "</div>";

      setHtmlVideoToModal(textError);
    }
  });
  request.send();
}
function setHtmlVideoToModal(response) {
  blockVideoContent.insertAdjacentHTML("beforeend", response);
  modalVideo.style.display = "block";
  lockScroll();
}
function videoServerHtml(src, type) {
  return (
    `
  <video class="video_in_modal" poster="" controls autoplay>
    <source src="` +
    src +
    `" type="` +
    type +
    `" />
    Your browser does not support HTML5 video.
  </video>
  `
  );
}

function videoLinkHtml(link) {
  return (
    `
    <iframe
            class="video_in_modal"
            src="` +
    link +
    `"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
  `
  );
}
function removeVideo() {
  let videoInModal = document.querySelector(".video_in_modal");
  let sketchfabModel = document.querySelector(".sketchfab-embed-wrapper");
  let sketchfabTextError = document.querySelector(".sketchfab_model_error");
  if (videoInModal !== null) {
    videoInModal.parentNode.removeChild(videoInModal);
  } else if (sketchfabModel !== null) {
    sketchfabModel.parentNode.removeChild(sketchfabModel);
  } else if (sketchfabTextError !== null) {
    sketchfabTextError.parentNode.removeChild(sketchfabTextError);
  }
}
addListenerOnEl();

export function closeModalESC(el) {
  document.addEventListener("keydown", function (e) {
    if (e.which === 27 && el !== null) {
      el.style.display = "none";
      unlockScroll();
      removeVideo();
    }
  });
}
closeModalESC(modalVideo);
// END VIDEO MODAL
